var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionStopTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#E9E9EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9775 20.0625C7.53754 20.0625 3.91504 16.4475 3.91504 12C3.91504 7.5525 7.53754 3.9375 11.9775 3.9375C16.4175 3.9375 20.04 7.5525 20.04 12C20.04 16.4475 16.425 20.0625 11.9775 20.0625ZM11.9775 5.0625C8.15254 5.0625 5.04004 8.175 5.04004 12C5.04004 15.825 8.15254 18.9375 11.9775 18.9375C15.8025 18.9375 18.915 15.825 18.915 12C18.915 8.175 15.8025 5.0625 11.9775 5.0625Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9521 15.7346H11.0471C9.14965 15.7346 8.26465 14.8496 8.26465 12.9521V11.0471C8.26465 9.14965 9.14965 8.26465 11.0471 8.26465H12.9521C14.8496 8.26465 15.7346 9.14965 15.7346 11.0471V12.9521C15.7346 14.8496 14.8496 15.7346 12.9521 15.7346ZM11.0471 9.38965C9.77965 9.38965 9.38965 9.77965 9.38965 11.0471V12.9521C9.38965 14.2196 9.77965 14.6096 11.0471 14.6096H12.9521C14.2196 14.6096 14.6096 14.2196 14.6096 12.9521V11.0471C14.6096 9.77965 14.2196 9.38965 12.9521 9.38965H11.0471Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionStopTransaction);
export default __webpack_public_path__ + "static/media/action-stop-transaction.eb0afd04af05eaf9af20f379a3964a22.svg";
export { ForwardRef as ReactComponent };